export default __webpack_public_path__ + "static/natalie hurley-5aa0d8ddc9822459a7b66851dc16c2f2.png";